import React from "react";
import { Grid } from "@mui/material";
import BasicInfo from "./BasicInfo";
import LandMarks from "./LandMarks";
import LandRights from "./LandRights";

function InfoArea() {
  return (
    <Grid
      container
      className="infoArea"
      direction="column"
      style={{ flexWrap: "nowrap", rowGap: "1rem" }}
    >
      <BasicInfo />
      <LandMarks />
      <LandRights />
    </Grid>
  );
}

export default InfoArea;
